import { gql } from '@apollo/client';

export const LOGIN_EMPLOYEE = gql`
    mutation LoginEmployee($email: String!, $password: String!){
        loginEmployee(data: { email: $email, password: $password })
    }
`;
